import { logger } from "../../helpers/tslog";

export const STORAGE_KEY_SelectedShapes = "selectedShapes";

export function setSelectedShape(shape) {
  try {
    localStorage.setItem(STORAGE_KEY_SelectedShapes, JSON.stringify(shape));
  } catch (err) {
    logger.error("Error saving selectedShape to localStorage:", err);
  }
}

export function removeSelectedShape() {
  localStorage.removeItem(STORAGE_KEY_SelectedShapes);
}

export function getSelectedShape() {
  const raw = localStorage.getItem(STORAGE_KEY_SelectedShapes);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (err) {
    logger.error("Error parsing selectedShape from localStorage:", err);
    return null;
  }
}

export function getSelectedShapeName() {
  const shape = getSelectedShape();
  return shape && typeof shape.name === "string" ? shape.name : null;
}
